<a class="mail-icon" (click)="onClickNeedHelp($event)" [title]="buttonTitle">
  <svg-icon name="mail" class="icon-large"></svg-icon>
</a>
